import React, { useEffect, useState } from 'react';
import { TheMasterContextProvider } from '../../MyContexts/Master_Context';
import Sidenavigation1 from '../../layouts/Sidenavigation1';
import Topnavigation from '../../layouts/Topnavigation';

import { MenuContextProvider } from '../../MyContexts/Rest_Context';
import ContactP from './ContactP';

const ContactPage = (props) => {

    const [thePage, setThePage] = useState();

    useEffect(() => {

        /// myFunctions.connCheck();

        if (props.newp) {
            setThePage(<ContactP newp={true} upContactList={(newitem) => props.upContactList(newitem)} />);
        }
        else {
            setThePage(<ContactP key={props.pageItem._id} pageId={props.pageItem._id}
                upContactList={(newitem) => props.upContactList(newitem)} />);
        }

    }, [props.pageItem])

    return (
        <div className="ms-body ms-aside-left-open ms-primary-theme ms-has-quickbar">

            <TheMasterContextProvider>
                <Sidenavigation1 />
                <main className="body-content">
                    <MenuContextProvider>
                        <Topnavigation />
                        {thePage}
                    </MenuContextProvider>
                </main>
                {/* <Quickbar /> */}
            </TheMasterContextProvider>

        </div>
    );
}

export default ContactPage;